module.exports = __webpack_public_path__ + "img/signature_db.684c31af.png";